export default class MergeTagModalController {
    constructor($uibModalInstance, $scope, $injector, guestlistId, hideNonGuestlist, scopedGuestlists, entityPrefix) {
        this.modalInstance = $uibModalInstance;
        this.scope = $scope;
        this.injector = $injector;

        this.guestlistId = guestlistId;
        this.hideNonGuestlist = hideNonGuestlist;
        this.scopedGuestlists = scopedGuestlists;
        this.entityPrefix = entityPrefix;

        this.currentSelectedPlaceholder = null;
    }

    handlePlaceholderSelect(placeholder) {
        this.currentSelectedPlaceholder = placeholder;
    }

    useCurrentPlaceholder() {
        this.modalInstance.close(this.currentSelectedPlaceholder);
    }

    dismiss() {
        this.modalInstance.dismiss();
    }
}

MergeTagModalController.$inject = [
    '$uibModalInstance',
    '$scope',
    '$injector',
    'guestlistId',
    'hideNonGuestlist',
    'scopedGuestlists',
    'entityPrefix'
];



// WEBPACK FOOTER //
// ./src/app/modules/merge-tags/controllers/helpers/placeholder-modal-controller.js